import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className = "footer">            
            <p >&copy;2020 William Morris - Web Dev Student</p>
        </footer>
    )
}

export default Footer